import { DateObject } from 'react-multi-date-picker'

export const isSameDate = (renderingDate: DateObject, comparisonDate: Date) =>
  comparisonDate.getFullYear() === renderingDate.year &&
  comparisonDate.getMonth() === renderingDate.month.index &&
  comparisonDate.getDate() === renderingDate.day

export const dateRangeContains = (renderingDate: DateObject, comparisonDates: Date[]) =>
  comparisonDates.some(date => isSameDate(renderingDate, date))
